module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/mobile-sms-icon-0927770834019e9a3282c3fe07247cb8.png";